<template>
<div>
    <!-- PROFESSIONS -->
    <v-card class="mt-6" style="border:6px solid #EBEBEB" v-if="top!=null && top.professions && loaded">    
        <div class="pa-6 cyan d-flex justify-space-between">
            <div class="white--text headline">PROFESSIONS</div>
            <v-icon small color="cyan darken-3">fa-plane-departure</v-icon>
        </div>
        
        <div class="pa-6">
            <div class="ml-4" v-if="top.professions.p1">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.professions.p1}}</div>
                <Gen :list="professionsP1" />
            </div>

            <div class="ml-4 mt-4" v-if="top.professions.p2">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.professions.p2}}</div>
                <Gen :list="professionsP2" />
            </div>

            <div class="ml-4 mt-4" v-if="top.professions.p3">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.professions.p3}}</div>
                <Gen :list="professionsP3" />
            </div>
        </div>
    </v-card>
    
    <!-- MAJORS -->
    <v-card class="mt-10" style="border:6px solid #EBEBEB" v-if="top!=null && top.majors && loaded">  
        <div class="pa-6 cyan d-flex justify-space-between">
            <div class="white--text headline">MAJORS</div>
            <v-icon small color="cyan darken-3">fa-plane-departure</v-icon>
        </div>

        <div class="pa-6">
            <div class="ml-4" v-if="top.majors.p1">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.majors.p1}}</div>
                <Gen :list="majorsP1" />
            </div>

            <div class="ml-4 mt-4" v-if="top.majors.p2">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.majors.p2}}</div>
                <Gen :list="majorsP2" />
            </div>

            <div class="ml-4 mt-4" v-if="top.majors.p3">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.majors.p3}}</div>
                <Gen :list="majorsP3" />
            </div>
        </div>
    </v-card>

    <!-- UNIVERSITIES -->
    <v-card class="mt-10" style="border:6px solid #EBEBEB" v-if="top!=null && top.universities && loaded">  
        <div class="pa-6 cyan d-flex justify-space-between">
            <div class="white--text headline">UNIVERSITIES</div>
            <v-icon small color="cyan darken-3">fa-plane-departure</v-icon>
        </div>
        <div class="pa-6">
            <div class="ml-4" v-if="top.universities.p1">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.universities.p1.name}}</div>
                <Gen :list="universitiesP1" />
            </div>

            <div class="ml-4 mt-4" v-if="top.universities.p2">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.universities.p2.name}}</div>
                <Gen :list="universitiesP2" />
            </div>

            <div class="ml-4 mt-4" v-if="top.universities.p3">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.universities.p3.name}}</div>
                <Gen :list="universitiesP3" />
            </div>
        </div>
    </v-card>

    <!-- COMPANIES -->
    <v-card class="mt-10" style="border:6px solid #EBEBEB" v-if="top!=null && top.companies && loaded">  
        <div class="pa-6 cyan d-flex justify-space-between">
            <div class="white--text headline">COMPANIES</div>
            <v-icon small color="cyan darken-3">fa-plane-departure</v-icon>
        </div>
        <div class="pa-6">
            <div class="ml-4" v-if="top.companies.p1">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.companies.p1}}</div>
                <Gen :list="companiesP1" />
            </div>

            <div class="ml-4 mt-4" v-if="top.companies.p2">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.companies.p2}}</div>
                <Gen :list="companiesP2" />
            </div>

            <div class="ml-4 mt-4" v-if="top.companies.p3">
                <div class="subtitle-1 font-weight-medium primary--text">{{top.companies.p3}}</div>
                <Gen :list="companiesP3" />
            </div>
        </div>
    </v-card>

    <!-- NOT -->
    <div class="pa-4 pa-sm-8" v-else>
        <div class="headline bPlanner--text">No contacts yet.</div>
    </div>
</div>
</template>

<script>
import Pocket from '@/components/planner/Pocket'
import Gen from '@/components/planner/Gen'

export default {
    data: () => ({
        loaded: false,
        professionsP1: [],
        professionsP2: [],
        professionsP3: [],
        majorsP1: [],
        majorsP2: [],
        majorsP3: [],
        universitiesP1: [],
        universitiesP2: [],
        universitiesP3: [],
        companiesP1: [],
        companiesP2: [],
        companiesP3: []
    }),
    props: ['item', 'top'],
    components: {
        Pocket,
        Gen
    },
    mounted() {
        if (this.item.professions) {
            for (let k in this.item.professions.p1) {
                this.professionsP1.push(this.item.professions.p1[k])
            }
            for (let k in this.item.professions.p2) {
                this.professionsP2.push(this.item.professions.p2[k])
            }
            for (let k in this.item.professions.p3) {
                this.professionsP3.push(this.item.professions.p3[k])
            }
        }

        if (this.item.majors) {
            for (let k in this.item.majors.p1) {
                this.majorsP1.push(this.item.majors.p1[k])
            }
            for (let k in this.item.majors.p2) {
                this.majorsP2.push(this.item.majors.p2[k])
            }
            for (let k in this.item.majors.p3) {
                this.majorsP3.push(this.item.majors.p3[k])
            }
        }

        if (this.item.universities) {
            for (let k in this.item.universities.p1) {
                this.universitiesP1.push(this.item.universities.p1[k])
            }
            for (let k in this.item.universities.p2) {
                this.universitiesP2.push(this.item.universities.p2[k])
            }
            for (let k in this.item.universities.p3) {
                this.universitiesP3.push(this.item.universities.p3[k])
            }
        }

        if (this.item.companies) {
            for (let k in this.item.companies.p1) {
                this.companiesP1.push(this.item.companies.p1[k])
            }
            for (let k in this.item.companies.p2) {
                this.companiesP2.push(this.item.companies.p2[k])
            }
            for (let k in this.item.companies.p3) {
                this.companiesP3.push(this.item.companies.p3[k])
            }
        }
        
        this.loaded = true;
    }
}
</script>